import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=3e54b8ae&scoped=true"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=3e54b8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54b8ae",
  null
  
)

export default component.exports